export default "__VITE_ASSET__s3tqqrTB__"